.row {
	position: relative;
	display: flex;
	align-items: center;
}

/* Inset to the title on the left and the row's padding on the right. */
.row + .row::before {
	content: '';
	position: absolute;
	top: 0;
	left: calc(var(--space-4) + 22px + var(--space-3));
	right: var(--space-4);
	height: 1px;
	/* Half the card's own border, so the dividers recede behind the text. */
	background: color-mix(in srgb, var(--border) 50%, var(--surface-card));
}

/* The row's padding sits on the label, so the tick zone runs from the card's
   edge to the title and the full height of the row. */
.check {
	align-self: stretch;
	padding: var(--space-2) var(--space-3) var(--space-2) var(--space-4);
}

/* Fills the rest of the row, so a tap anywhere past the checkbox edits. */
.title {
	flex: 1;
	min-width: 0;
	margin: 0;
	padding: var(--space-2) var(--space-4) var(--space-2) 0;
	border: none;
	background: none;
	color: inherit;
	font: inherit;
	text-align: left;
	overflow-wrap: anywhere;
}

button.title {
	cursor: text;
}

.ticked {
	color: var(--ink-muted);
	text-decoration: line-through;
}

.editor {
	flex: 1;
	min-width: 0;
	margin: var(--space-1) var(--space-4) var(--space-1) 0;
	padding: var(--space-1) var(--space-2);
	background: var(--surface-input);
	border: 1px solid var(--accent-sage);
	border-radius: var(--radius-sm);
	color: var(--ink);
	font: inherit;
	outline: none;
}
